import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tel'
})
export class TelPipe implements PipeTransform {
  transform(value: string, isAfricaphoneCode?: any): any {
    if (!value) {
      return value;
    }
    if(isAfricaphoneCode){
      const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,3})/);
      return !x[2] ? x[1] : x[1]  + x[2] + (x[3] ? x[3] : '');
    }
    else{
      const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      return !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
    }
    
  }
}
